/**
 * This regex will match the liquidity portal unauthenticated path (Mostly before login and redirections)
 *  - Login
 *  - Reset password (Page redirection from Email after Forgot password)
 *  - Set password (This is the page on initial invite of a market maker)
 *  - Forgot password (Page before reset password)
 *  - Email redirect - Captures most email redirection and query string after
 *  - Token expired - After email redirection and token expired page
 */
export const unauthenticatedLiquidityPaths =
  /^https:\/\/(?:(?:local|dev|staging)\.)?liquidity\.forgd\.com(?::3001)?(?:\/(?:reset-password|set-password|forgot-password|email-redirect|login|token-expired)?(?:\/|[?#].*)?)?$/
